var _path, _mask, _g, _mask2, _g2, _mask3, _g3, _path2, _mask4, _g4, _mask5, _g5, _mask6, _g6, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHexborder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.552 287.859C429.924 293.24 429.924 306.76 420.552 312.141L249.292 410.474C239.959 415.833 228.321 409.095 228.321 398.333L228.321 201.667C228.321 190.905 239.959 184.167 249.292 189.526L420.552 287.859Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 8,
    width: 501,
    height: 558
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.233 15.1526C301.576 5.76924 321.671 5.76924 338.014 15.1526L534.755 128.116C551.215 137.567 561.365 155.098 561.365 174.078V399.5C561.365 418.48 551.215 436.011 534.755 445.462L338.014 558.425C321.671 567.809 301.576 567.809 285.233 558.425L88.4918 445.462C72.0318 436.011 61.8822 418.48 61.8822 399.5L61.8822 174.078C61.8822 155.098 72.0318 137.567 88.4918 128.116L285.233 15.1526Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 876.654,
    height: 311.992,
    transform: "matrix(0.867216 0.497932 -0.502071 0.864826 163.284 -212.477)",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 21,
    width: 501,
    height: 558
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.986 28.3636C278.328 18.9802 298.424 18.9802 314.767 28.3636L511.508 141.327C527.968 150.778 538.118 168.309 538.118 187.289V412.71C538.118 431.691 527.968 449.222 511.508 458.673L314.767 571.636C298.424 581.02 278.328 581.02 261.986 571.636L65.2447 458.673C48.7847 449.222 38.6351 431.691 38.6351 412.71L38.6351 187.289C38.6351 168.309 48.7847 150.778 65.2447 141.327L261.986 28.3636Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -56.457,
    y: -78.165,
    width: 298.893,
    height: 800.367,
    fill: "white"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 34,
    width: 501,
    height: 558
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.233 41.5745C301.576 32.1911 321.671 32.1911 338.014 41.5745L534.755 154.538C551.215 163.989 561.365 181.52 561.365 200.5V425.921C561.365 444.902 551.215 462.433 534.755 471.884L338.014 584.847C321.671 594.231 301.576 594.231 285.233 584.847L88.4918 471.884C72.0318 462.433 61.8822 444.902 61.8822 425.921L61.8822 200.5C61.8822 181.52 72.0318 163.989 88.4918 154.538L285.233 41.5745Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730.729,
    height: 349.475,
    transform: "matrix(0.867216 -0.497932 0.502071 0.864826 -4.42773 546.605)",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.714 287.374C415.086 292.755 415.086 306.275 405.714 311.656L256.932 397.083C247.599 402.442 235.961 395.704 235.961 384.942L235.961 214.089C235.961 203.327 247.599 196.589 256.932 201.948L405.714 287.374Z",
    fill: "white"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 39,
    width: 447,
    height: 498
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.098 46.2715C300.441 36.8881 320.537 36.8881 336.879 46.2715L507.311 144.129C523.771 153.58 533.921 171.111 533.921 190.091V385.301C533.921 404.281 523.771 421.812 507.311 431.263L336.879 529.121C320.537 538.504 300.441 538.504 284.098 529.121L113.666 431.263C97.2059 421.812 87.0563 404.281 87.0563 385.301L87.0563 190.092C87.0563 171.111 97.2059 153.58 113.666 144.129L284.098 46.2715Z",
    fill: "#002E5D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 784.303,
    height: 279.125,
    transform: "matrix(0.867216 0.497932 -0.502071 0.864826 177.775 -158.975)",
    fill: "#002E5D"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 51,
    width: 448,
    height: 497
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.299 58.0908C279.642 48.7075 299.738 48.7075 316.08 58.0909L486.513 155.948C502.973 165.399 513.122 182.931 513.122 201.911V397.12C513.122 416.1 502.973 433.632 486.513 443.083L316.08 540.94C299.738 550.324 279.642 550.324 263.299 540.94L92.8671 443.083C76.4071 433.632 66.2575 416.1 66.2575 397.12L66.2575 201.911C66.2575 182.931 76.4071 165.399 92.8671 155.948L263.299 58.0908Z",
    fill: "#0582CA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.8174,
    y: -38.812,
    width: 267.406,
    height: 716.052,
    fill: "#0582CA"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 62,
    width: 447,
    height: 498
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.098 69.9102C300.441 60.5268 320.537 60.5268 336.879 69.9102L507.311 167.768C523.771 177.219 533.921 194.75 533.921 213.73V408.939C533.921 427.92 523.771 445.451 507.311 454.902L336.879 552.759C320.537 562.143 300.441 562.143 284.098 552.759L113.666 454.902C97.2059 445.451 87.0563 427.92 87.0563 408.94L87.0563 213.73C87.0563 194.75 97.2059 177.219 113.666 167.768L284.098 69.9102Z",
    fill: "#0057B8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 653.751,
    height: 312.659,
    transform: "matrix(0.867216 -0.497932 0.502071 0.864826 27.7314 520.142)",
    fill: "#0057B8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.531 51.2946L276.359 219.447L128.979 135.166L275.531 51.2946Z",
    fill: "#002E5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.383 361.326L248.428 532.254L99.3792 446.52L248.383 361.326Z",
    fill: "#0582CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexborder);
export default __webpack_public_path__ + "static/media/hexborder.b52849a17c7c7893522b02b6ec6cf745.svg";
export { ForwardRef as ReactComponent };